import React from 'react';
import { DateTimePicker2 as DateTimePicker } from './FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import { dateTimePickerFormat } from '@/util/util.jsx';
import momentLocalizer from 'react-widgets-moment';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
moment.locale('en');
momentLocalizer();
import './datetimepicker.css';

export default class FromToDatePickers extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeFrom = this.onChangeFrom.bind(this);
    this.onChangeTo = this.onChangeTo.bind(this);
    this.toggleFrom = this.toggleFrom.bind(this);
    this.toggleTo = this.toggleTo.bind(this);
    this.state = { valueFrom: this.props.defaultValueFrom, valueTo: this.props.defaultValueTo,
      openFrom: false, openTo: false };
  }

  componentWillReceiveProps(props) {
    if (this.props.defaultValueFrom != props.defaultValueFrom) {
      this.setState({ valueFrom: props.defaultValueFrom });
    }
    if (this.props.defaultValueTo != props.defaultValueTo) {
      this.setState({ valueTo: props.defaultValueTo });
    }
  }

  onChangeFrom(v, strDate) {
    const valueFrom = (strDate && moment(strDate, 'DD MMM YYYY').toDate()) || null;
    if (this.props.onChangeFrom) {
      this.props.onChangeFrom(valueFrom);
    }
    this.setState({ valueFrom, openFrom: false });
    if (this.props.bindSelect) {
      if (!this.state.valueTo && valueFrom) {
        if (this.props.onChangeTo) {
          this.props.onChangeTo(valueFrom);
        }
        this.setState({ valueTo: valueFrom, openTo: 'date' });
      }
    }
  }
  onChangeTo(v, strDate) {
    const valueTo = (strDate && moment(strDate, 'DD MMM YYYY').toDate()) || null;
    if (this.props.onChangeTo) {
      this.props.onChangeTo(valueTo);
    }
    this.setState({ valueTo, openTo: false });
    if (this.props.bindSelect) {
      if (!this.state.valueFrom && valueTo) {
        if (this.props.onChangeFrom) {
          this.props.onChangeFrom(valueTo);
        }
        this.setState({ valueFrom: valueTo, openFrom: 'date' });
      }
    }
  }

  toggleFrom(view) {
    this.setState({ openFrom: view });
  }
  toggleTo(view) {
    this.setState({ openTo: view });
  }
  render() {
    return (
      <Row>
        <Col md={6} xs={6}>
          {this.props.hideLabels ?
            <DateTimePicker
              className="dual-datepickers"
              format={dateTimePickerFormat}
              time={false}
              name={this.props.nameFrom}
              onChange={this.onChangeFrom}
              defaultValue={this.state.valueFrom}
              open={this.state.openFrom}
              defaultOpen={false}
              onToggle={this.toggleFrom}
              disabled={this.props.disabled}
            />
            :
            <Label
              label={this.props.labelFrom}
              vertical={this.props.vertical}
              childStyle={this.props.labelChildStyle}
              sm={this.props.labelSm}
              style={this.props.labelStyle}
            >
              <DateTimePicker
                className="dual-datepickers"
                format={dateTimePickerFormat}
                time={false}
                name={this.props.nameFrom}
                onChange={this.onChangeFrom}
                defaultValue={this.state.valueFrom}
                open={this.state.openFrom}
                defaultOpen={false}
                onToggle={this.toggleFrom}
                disabled={this.props.disabled}
              />
            </Label>
          }
        </Col>
        <Col md={6} xs={6}>
          {this.props.hideLabels ?
            <DateTimePicker
              className="dual-datepickers"
              format={dateTimePickerFormat}
              time={false}
              name={this.props.nameTo}
              onChange={this.onChangeTo}
              min={this.state.valueFrom}
              defaultValue={this.state.valueTo}
              open={this.state.openTo}
              defaultOpen={false}
              onToggle={this.toggleTo}
              disabled={this.props.disabled}
            />
            :
            <Label
              label={this.props.labelTo}
              vertical={this.props.vertical}
              childStyle={this.props.labelChildStyle}
              sm={this.props.labelSm}
              style={this.props.labelStyle}
            >
              <DateTimePicker
                className="dual-datepickers"
                format={dateTimePickerFormat}
                time={false}
                name={this.props.nameTo}
                onChange={this.onChangeTo}
                defaultValue={this.state.valueTo}
                min={this.state.valueFrom}
                open={this.state.openTo}
                defaultOpen={false}
                onToggle={this.toggleTo}
                disabled={this.props.disabled}
              />
            </Label>
          }
        </Col>
      </Row>
    );
  }
}
FromToDatePickers.propTypes = {
  label: React.PropTypes.string,
  labelStyle: React.PropTypes.object,
  labelChildStyle: React.PropTypes.object,
  labelSm: React.PropTypes.number,
  vertical: React.PropTypes.bool,
  onChangeFrom: React.PropTypes.func,
  onChangeTo: React.PropTypes.func,
  defaultValueTo: React.PropTypes.object,
  defaultValueFrom: React.PropTypes.object,
  nameFrom: React.PropTypes.string,
  nameTo: React.PropTypes.string,
  labelFrom: React.PropTypes.string,
  labelTo: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  bindSelect: React.PropTypes.bool,
  hideLabels: React.PropTypes.bool,
};
